<div class="auth-signatory" [class.control-like]="controlLike">
  @if (isEdit) {
    <div class="d-flex align-items-start gap-1">
      <div class="flex-grow-1">
        <app-multiple-name-input
          [formControl]="authSignatoriesControl"
          [isDisabled]="authSignatoriesControl.disabled || !allowEdit || isLoading"
          [customErrors]="customErrors"
          [tip]="tip"
        />
      </div>

      <div class="d-flex gap-1">
        <button
          type="button"
          class="btn btn-primary btn-icon save-btn"
          [disabled]="isLoading"
          (click)="save()"
        >
          <i class="icon ic-checkmark-circle-20"></i>
        </button>

        <button
          type="button"
          class="btn btn-secondary btn-icon close-btn"
          [disabled]="isLoading"
          (click)="cancelEditing()"
        >
          <i class="icon ic-cancel-circle-20"></i>
        </button>


      </div>
    </div>
  } @else {
    <div>
      <div class="label-wrapper">
        <div class="label">{{ authSignatories }}</div>

        <button
          type="button"
          class="btn btn-secondary btn-icon edit-btn"
          [disabled]="!allowEdit || isLoading"
          (click)="startEditing()"
        >
          <i class="icon ic-edit-20"></i>
        </button>
      </div>

      <app-validation-error [control]="authSignatoriesControl" [customErrors]="customErrors"/>
    </div>
  }
</div>
